import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import Chip from '@material-ui/core/Chip'
import CircularProgress from '@material-ui/core/CircularProgress'
import CompanyService from '../../services/CompanyService'

export default (props) => {

  const [companies, setCompanies] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const searchCompanyByTerm = (term) => {
    
    setLoading(true)     

    if(!term || term.length < 2) return 

    setLoading(true)
    const companiesResponse = CompanyService.companies(term)
    companiesResponse
      .then(resp => {        
        setCompanies(resp.data)
        setLoading(false)             
      })
      .catch(err => {
        setLoading(false)             
        console.error(err)
      })    
  }

  const handleSearchCompanyDefault = (props, event) => {                  
    searchCompanyByTerm('ads')  
  }

  const handleCompany = (event) => {                  
    searchCompanyByTerm(event.target.value.trim())  
  }

  const handleCompanySelectItem = (option, param) => {     
    if(props.setAutoCompleteContent && typeof props.setAutoCompleteContent == "function")
      props.setAutoCompleteContent(param)
  }

  return (           
    <div>          
      <Autocomplete                   
          {...props}
          value={props.value}
          selectOnFocus              
          filterSelectedOptions
          options={companies}     
          onKeyUp={handleCompany}                    
          onChange={handleCompanySelectItem}        
          getOptionLabel={(option) => {                                    
            return option.id +" - " + option.label;
          }}            
          renderOption={(option) => {                                    
            return `${option.id} | ${option.label} | ${option.identifier ? `cnpj ${option.identifier}`:''}`
          }}
          getOptionSelected={(option, value) => option.label === value.label}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip                                  
                  color="primary" 
                  label={option.label} 
                  {...getTagProps({ index })} 
                  />
            ))
          }
          loading={loading}
          renderInput={(params) => (
            <TextField
              label="Empresa"
              {...params}     
              onClick={handleSearchCompanyDefault}               
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      </div>     
  )
}